module.exports = __webpack_public_path__ + "static/media/dropdown.bee7f037.svg";